/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import React from 'react';
import { CompanyType } from 'src/enums';
import { ContactFormData, ContactFormResponse } from './interfaces';

export const getIndicatorName = (company_type: number) => {
  switch (company_type) {
    case 2:
      return 'Franqueador';
    case 4:
      return 'Fornecedor';
    default:
      return 'Indicador';
  }
};

const getUserName = (company_type: number) => {
  switch (company_type) {
    case 1:
      return 'franqueados';
    case 3:
      return 'lojistas';
    default:
      return 'lojistas/franqueados';
  }
};

const validateCnpj = (cnpj: string): boolean => {
  // Funciona para numérico e alfanumérico: dígitos → 0-9, letras → 17-42
  const toNum = (char: string) => char.toUpperCase().charCodeAt(0) - 48;

  const calcDv = (chars: string[], weights: number[]): number => {
    const sum = chars.reduce((acc, ch, i) => acc + toNum(ch) * weights[i], 0);
    const rem = sum % 11;
    return rem < 2 ? 0 : 11 - rem;
  };

  // Cobre ambos os formatos: 14 dígitos OU 12 alfanuméricos + 2 DVs numéricos
  if (!/^[A-Z0-9]{12}\d{2}$/i.test(cnpj)) return false;

  const chars = cnpj.toUpperCase().split('');
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const dv1 = calcDv(chars.slice(0, 12), w1);
  const dv2 = calcDv(chars.slice(0, 13), w2);

  return dv1 === toNum(chars[12]) && dv2 === toNum(chars[13]);
};

export const isDebtor = (company_type: number) =>
  company_type === CompanyType.debtor ||
  company_type === CompanyType.franchisee;

export const verifyCnpj = (
  value: string,
  setValidCnpj: (isValid: boolean | null) => void,
) => {
  // Remove apenas pontuação/formatação, preservando letras do novo CNPJ alfanumérico
  const gotCnpj = value.replace(/[^a-zA-Z0-9]/g, '');

  if (gotCnpj.length === 14) {
    setValidCnpj(validateCnpj(gotCnpj));
  } else if (gotCnpj.length < 14 && gotCnpj.length > 0) {
    setValidCnpj(false);
  } else {
    setValidCnpj(null);
  }
};

export const setSuccessMessage = (
  userValidation: ContactFormResponse,
  company_type: CompanyType,
): React.ReactElement => {
  if (isDebtor(company_type)) {
    if (
      userValidation.is_creditor_stone_client &&
      !userValidation.is_creditor_unio_client
    ) {
      return (
        <p>
          {`Entraremos em contato com seu ${getIndicatorName(
            company_type,
          )} para apresentar o Unio!`}
        </p>
      );
    }
  } else if (userValidation.is_creditor_stone_client) {
    return (
      <p>
        <p>
          {`Indique seus ${getUserName(
            company_type,
          )} para aproveitar os benefícios do Unio! Envie esse link para eles e peça para se cadastrarem:`}
        </p>
        <a
          href="https://unio.stone.com.br/#/userform"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://unio.stone.com.br/#/userform
        </a>
      </p>
    );
  }
  return <></>;
};

export const formatFormCnpj = (formData: ContactFormData): ContactFormData => {
  formData.document = formData.document.replace(/[^a-zA-Z0-9]/g, '');

  if (formData.indicator?.document) {
    formData.indicator.document = formData.indicator.document.replace(
      /[^a-zA-Z0-9]/g,
      '',
    );
  } else {
    delete formData.indicator;
  }

  return formData;
};
